import { useState } from "react";
import * as PR from "../../prime-modules/index";
import { filterCountryName } from "../../utils/reuse";

const RoamingColumn = ({ data, showCount = true }) => {
  const [showCountries, setShowCountries] = useState(false);

  const countries = data?.bundle?.countries || [];
  const countryName = countries.map(
    (country) => country.country?.name || "Unknown"
  );
  const roamingCountries = data?.roamingcountries || [];
  const countriesList = roamingCountries
    .map((item) => item.country.name)
    .sort((a, b) => a.localeCompare(b));

  return (
    <div>
      {roamingCountries.length === 0 && <span>{filterCountryName(countryName.join(", "))}</span>}
      {roamingCountries.length === 1 && <span>{filterCountryName(countriesList[0])}</span>}

      {roamingCountries.length > 1 && (
        <span className="flex align-items-center">
          {showCount && `${roamingCountries.length} Countries`}
          {/* Info icon */}
          <i
            className="pi pi-wifi ml-2"
            onClick={() => setShowCountries(!showCountries)}
            style={{ cursor: "pointer" }}
            title={`Roaming countries (${data?.roamingcountries?.length})`}
          />
        </span>
      )}

      {/* Dialog for showing countries list */}
      {showCountries && (
        <PR.Dialog
          header="Roaming Countries"
          visible={showCountries}
          onHide={() => setShowCountries(false)}
          dismissableMask
          className="roaming-countries"
          draggable={false}
          resizable={false}
          blockScroll={true}
        >
          <div className="columnCount">
            {countriesList.map((country, index) => (
              <div key={index} className="countries-list">
                <span
                  style={{
                    display: "inline-block",
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: "#f73759",
                    marginRight: "5px",
                  }}
                />{" "}
                {filterCountryName(country)}
              </div>
            ))}
          </div>
        </PR.Dialog>
      )}
    </div>
  );
};

export default RoamingColumn;
